import moment from 'moment';
import React, { useState, useEffect } from 'react';
import Avatar from '../../Avatar';
import { Attachments } from 'src/pages/ServiceRequests/components/Attachments';
import { isImage } from 'src/helpers/CommonHelpers';
import GenericDialogue from 'src/components/Dialogue/Dialogue';
import './MessagesRepeater.scss';

const MESSAGE_TRUNCATE_LENGTH = 300;

const MessagesRepeater = ({
  notes,
  user,
  onSendEmailNotification,
  onImageClicked,
  tabSelections,
}) => {
  const { allowedTabList } = tabSelections ?? { allowedTabList: [] };
  const [allowVideoChat, setAllowVideoChat] = useState(true);
  const [expandedMessage, setExpandedMessage] = useState<any>(null);

  useEffect(() => {
    const videoChat = allowedTabList.filter(
      (item: any) => item.name === 'Video Chat'
    )[0];

    setAllowVideoChat(videoChat !== undefined);
  }, []);

  return (
    <>
      <div>
        {notes.map((note: any, x: number) => {
          const isLong: boolean = note.message?.length > MESSAGE_TRUNCATE_LENGTH;

          const displayText = isLong
            ? `${note.message.slice(0, MESSAGE_TRUNCATE_LENGTH)}…`
            : note.message;

          return (
            <div key={x} className="msg-repeater-item">
              <div className="msg-repeater-author">
                <div className="msg-repeater-avatar">
                  <Avatar size="badge" url={note.sentByImage} />
                  {note.sentBy !== user.id &&
                    allowVideoChat &&
                    user.roles[0].role.name !== 'Realtor' && (
                      <div
                        className="msg-repeater-video"
                        onClick={(e) => {
                          e.stopPropagation();
                          onSendEmailNotification(note);
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        <img
                          src={'/assets/icon-chat.png'}
                          className="msg-repeater-chat-icon"
                          alt="video chat"
                        />
                      </div>
                    )}
                </div>
                <div>
                  <div className="msg-repeater-username">{note.sentByName}</div>
                  <div className="msg-repeater-body" style={{ whiteSpace: 'pre-line' }}>
                    {displayText}
                    {isLong && (
                      <span
                        className="msg-repeater-read-more"
                        onClick={() => setExpandedMessage(note)}
                      >
                        {' '}Read more
                      </span>
                    )}
                  </div>
                  {note.fileURL && isImage(note.fileURL) ? (
                    <Attachments
                      attachments={{
                        hasAttachment: true,
                        firstCompressedAttachment: note.fileURL,
                        totalAttachments: 1,
                      }}
                      onClickAttachment={() => onImageClicked(x, note)}
                      fromMessages
                      fileName={note.fileName}
                    />
                  ) : note.fileURL && note.fileURL.toLowerCase().includes('.pdf') ? (
                    <Attachments
                      attachments={{ hasAttachment: true, totalAttachments: 1 }}
                      onClickAttachment={() => onImageClicked(x, note)}
                      fromMessages
                      isPdf
                      fileName={note.fileName}
                    />
                  ) : note.fileName ? (
                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={() => onImageClicked(x, note)}
                    >
                      {note.fileName}
                    </div>
                  ) : null}
                  <div className="msg-repeater-date">
                    {moment(note.sentOn).format('MM/DD/YYYY hh:mm A')}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <GenericDialogue
        isOpen={!!expandedMessage}
        onClose={() => setExpandedMessage(null)}
        title={expandedMessage?.sentByName ?? ''}
        description={moment(expandedMessage?.sentOn).format('MM/DD/YYYY hh:mm A')}
        maxWidth="80rem"
        avatar={<Avatar size="badge" url={expandedMessage?.sentByImage} />}
      >
        <div className="msg-expanded-body">
          {expandedMessage?.fileURL && (isImage(expandedMessage.fileURL) || expandedMessage.fileURL.toLowerCase().includes('.pdf')) && (
            <div
              className="msg-expanded-attachment"
              onClick={() => window.open(expandedMessage.fileURL, '_blank')}
            >
              <Attachments
                attachments={{
                  hasAttachment: true,
                  firstCompressedAttachment: isImage(expandedMessage.fileURL) ? expandedMessage.fileURL : undefined,
                  totalAttachments: 1,
                }}
                onClickAttachment={() => window.open(expandedMessage.fileURL, '_blank')}
                fromMessages
                isPdf={expandedMessage.fileURL.toLowerCase().includes('.pdf')}
                fileName={expandedMessage.fileName}
              />
            </div>
          )}
          <p className="msg-expanded-text">
            {expandedMessage?.message}
          </p>
        </div>
      </GenericDialogue>
    </>
  );
};

export default MessagesRepeater;
